import type PlainDate from '@Domain/PlainDate';

class CreateBeneficiary {
	constructor(
		public readonly facilityId: number,
		public readonly firstName: string,
		public readonly lastName: string,
		public readonly birthName: string | null,
		public readonly birthDate: PlainDate | null,
		public readonly homeAddress: string | null,
		public readonly phoneNumber: string | null,
		public readonly nationalHealthIdentifier: string | null,
		public readonly assignedUserIds: readonly number[],
	) {
		Object.freeze(this);
	}

	// `facilityId` is the route identifier: it must never be echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			firstName: this.firstName,
			lastName: this.lastName,
			birthName: this.birthName,
			birthDate: this.birthDate !== null ? this.birthDate.toApi() : null,
			homeAddress: this.homeAddress,
			phoneNumber: this.phoneNumber,
			nationalHealthIdentifier: this.nationalHealthIdentifier,
			assignedUserIds: this.assignedUserIds,
		};
	}
}

export default CreateBeneficiary;
